// extracted by mini-css-extract-plugin
export default {"DashboardCalendar":"DashboardCalendar_DashboardCalendar__hElP8","MiniCalendarAddEvent":"DashboardCalendar_MiniCalendarAddEvent__DZkPw"};